export const PROVIDERS = {
	MITID: 'MITID'
};

export const GENERAL_ERROR = 'GENERAL_ERROR';
